var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pb-0" },
    [
      _c(
        "v-card",
        {
          staticClass: "soli-round mb-5 stripe-shadow",
          attrs: { outlined: "" },
        },
        [
          _c(
            "v-list",
            { staticClass: "px-3", attrs: { dense: "" } },
            [
              _vm.subtotal !== null
                ? _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-subtitle",
                        { staticClass: "pb-0 justify-start flex" },
                        [_vm._v("Subtotal")]
                      ),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-list-item-subtitle",
                        { staticClass: "flex justify-end" },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.formatUnitAmount(_vm.subtotal)) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.appliedGift
                ? _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-subtitle",
                        { staticClass: "justify-start flex" },
                        [
                          _vm._v(
                            _vm._s(
                              `${_vm.appliedGift.code} · ${_vm.formatUnitAmount(
                                _vm.appliedGift.amount
                              )}`
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-list-item-subtitle",
                        { staticClass: "justify-end flex" },
                        [
                          _vm._v(
                            _vm._s(
                              `- ${_vm.formatUnitAmount(
                                _vm.appliedGift.discount
                              )}`
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.appliedPromo
                ? _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-subtitle",
                        { staticClass: "justify-start flex" },
                        [
                          _vm._v(
                            _vm._s(
                              `${_vm.appliedPromo.code} · ${_vm.appliedPromo.name}`
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-list-item-subtitle",
                        { staticClass: "justify-end flex" },
                        [
                          _vm._v(
                            _vm._s(
                              `- ${_vm.formatUnitAmount(
                                _vm.appliedPromo.amount
                              )}`
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.subtotal !== null
                ? _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-subtitle",
                        { staticClass: "pb-0 justify-start flex" },
                        [_vm._v("Amount Due")]
                      ),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-list-item-title",
                        { staticClass: "flex justify-end title soli-grey" },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.formatUnitAmount(_vm.totalAmountDue)) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _c("v-skeleton-loader", {
                    attrs: { type: "list-item-two-line" },
                  }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.prices.length
        ? _c("ShoppingCartPromo", {
            attrs: {
              errors: _vm.errors,
              prices: _vm.prices,
              subtotal: _vm.subtotal,
              guest: _vm.guest,
            },
            on: {
              applyPromo: function ($event) {
                return _vm.applyPromo($event)
              },
              applyGift: function ($event) {
                return _vm.applyGift($event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          staticStyle: { "min-height": "200px" },
          attrs: { id: "payment-form" },
        },
        [
          _c("div", { attrs: { id: "payment-element" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "error-message" } }),
        ]
      ),
      _vm._v(" "),
      _c("v-card-text", { staticClass: "my-4" }, [
        _vm._v(
          "\n        This will schedule an assessment lesson with\n        "
        ),
        _c("a", [_vm._v(_vm._s(_vm.teacherName))]),
        _vm._v(" risk free with our\n        "),
        _c(
          "a",
          {
            attrs: {
              href: "https://musicologielessons.com/why-choose-musicologie",
              target: "_blank",
            },
          },
          [_vm._v("Perfect Match Promise")]
        ),
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.totalAmountDue
                ? `Your card will be charged ${_vm.formatUnitAmount(
                    _vm.totalAmountDue
                  )}`
                : "Your card will not be charged"
            ) +
            ". You'll receive a welcome email at "
        ),
        _c("a", [_vm._v(_vm._s(_vm.guest.email))]),
        _vm._v(" with\n        further instructions.\n    "),
      ]),
      _vm._v(" "),
      _vm.errors
        ? _c("p", { staticClass: "caption red--text mx-auto" }, [
            _vm._v(
              "\n        " + _vm._s(Object.values(_vm.errors)[0]) + "\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("SoliBtn", {
        attrs: {
          gradient: "gradient-orange",
          text: "Book It!",
          icon: "music_note",
          block: "",
          loading: _vm.loading,
        },
        on: {
          click: function ($event) {
            return _vm.submitManualCard()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }